var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sound-element-wrapper",attrs:{"title":"单击播放"},on:{"click":_vm.play}},[_c('a-icon',{staticStyle:{"margin-right":"5px"},attrs:{"type":"play-circle","spin":_vm.playing}}),_vm._v("\n  "+_vm._s(_vm.second + '"')+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }